import React, { useEffect, useState, useContext } from "react";
import { AppContext } from "../../context/AppContext";
import "../../assets/css/crmphonebook/crmnew.css";
import ApiConfig from "../../api/ApiConfig";
import { simpleGetCall } from "../../api/ApiServices";
import { useParams } from "react-router-dom";

const CompleteWorkFlowChart = () => {
  const [workflowData, setWorkflowData] = useState([]);
  const { sidebar, selectedDomainId } = useContext(AppContext);
  const [loading, setLoading] = useState(false)

  const { id } = useParams()
  console.log("TCID", id);


  const fetchList = async () => {
    setLoading(true)

    try {
      const response = await simpleGetCall(
        `${ApiConfig.GET_TEST_CASES}test_case_code_id=${id}&domain_id=${selectedDomainId}`
      );
      if (response.success === true && response.data.length > 0) {
        const data = response.data[0];

        const formattedWorkflows = [
          ...data.predecessor_test_case_array.map((item, index) => ({
            attempt: index + 1,
            testCaseId: item.test_case_code_id,
            description: item.test_case_description,
            steps: item.test_steps.split(", "),
          })),
          {
            attempt: data.predecessor_test_case_array.length + 1,
            testCaseId: data.test_case_code_id,
            description: data.test_case_description,
            steps: data.test_steps.split(", "),
          },
          ...data.successor_test_case_array.map((item, index) => ({
            attempt: data.predecessor_test_case_array.length + 2 + index,
            testCaseId: item.test_case_code_id,
            description: item.test_case_description,
            steps: item.test_steps.split(", "),
          })),
        ];

        setWorkflowData(formattedWorkflows);
        setLoading(false)

      } else {
        console.log("Workflow data not found.");
      }
    } catch (err) {
      console.error("API Error:", err);
    }
  };

  useEffect(() => {
    fetchList();
  }, [selectedDomainId, id]);

  return (
    <div className={sidebar ? "taskMain " : "cx-active taskMain"} id="cx-main">
      <div className="sub-header-role">

        <h6 className="mt-2 role-text">Test Case</h6>
      </div>
      <div className="workflow-container">
        <div className="workflow-horizontal" style={{ display: "flex", flexDirection: "column" }}>
          <div className="workflow-container" style={{ display: "flex" }}>
            <div className="workflow-tree-wrapper">
              <div className="chart-heading-box tree-root">
                <h4 className="chart-heading">Test Case</h4>
              </div>
              <div className="tree-line" />
              <div className="tree-horizontal-line" />
              <div className="workflow-horizontal tree-branches">
                {workflowData.map((workflow, index) => (
                  <div className="workflow-box-wrapper" key={index}>
                    <div className="tree-line" />
                    <div className="arrow-down" />
                    <div className="workflow-box">
                      <div className="workflow-title">Attempt #{workflow.attempt}</div>
                      <div className="workflow-title">Test Case ID: {workflow.testCaseId}</div>
                      <div className="workflow-title">
                        <div className="wfd1">Test Case Description</div>
                        <div className="wfd">{workflow.description}</div>
                      </div>
                      <div className="workflow-title">
                        <div>Test Case Steps:</div>
                        <div className="wfd">
                          <ol>
                            {workflow.steps.map((step, stepIndex) => (
                              <li key={stepIndex}>{step}</li>
                            ))}
                          </ol>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompleteWorkFlowChart;